import { csrfToken } from "./csrf"

// Profile-page-style toggle chips for group membership, shared by the
// "Edit connections" modals on the tree pages and the network index.
export function renderGroupChips(container, groups, isMember, onToggle) {
    container.replaceChildren()
    groups.forEach((group) => {
        let chip = document.createElement("button")
        chip.type = "button"
        chip.className = "contact-chip contact-group-chip"
        let icon = document.createElement("i")
        icon.className = `bi ${group.icon} contact-group-chip-icon`
        icon.setAttribute("aria-hidden", "true")
        let label = document.createElement("span")
        label.className = "contact-group-chip-label"
        label.textContent = group.name
        let plus = document.createElement("i")
        plus.className = "bi bi-plus-lg contact-group-chip-plus"
        plus.setAttribute("aria-hidden", "true")
        let check = document.createElement("i")
        check.className = "bi bi-check-lg contact-group-chip-check"
        check.setAttribute("aria-hidden", "true")
        chip.append(icon, label, plus, check)
        setChipMember(chip, isMember(group))
        chip.addEventListener("click", (event) => {
            event.preventDefault()
            onToggle(group, chip)
        })
        container.appendChild(chip)
    })
}

export function setChipMember(chip, member) {
    chip.classList.toggle("is-active", member)
    chip.setAttribute("aria-pressed", member ? "true" : "false")
}

export function requestGroupMembership(contactsBase, contactId, slug, method) {
    return fetch(`${contactsBase}/${contactId}/groups/${encodeURIComponent(slug)}`, {
        method,
        headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
        credentials: "same-origin"
    }).then((response) => response.json().then((data) => ({ response, data })))
}
